import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { Button, Spin } from 'antd';

import { QUERY_PMS_LIST } from './quires';

import EmptyPage from './empty-page';
import PMSList from './pms-list';
import CreatePMSModal from './pms-modal';

const PMSIntegrations = () => {
  const { t } = useTranslation();
  const [pmsList, setPmsList] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleCancelCreateModal = () => {
    setShowCreateModal(false);
  };

  const handleShowCreateModal = () => {
    setShowCreateModal(true);
  };

  const [queryPMSList, { loading }] = useLazyQuery(QUERY_PMS_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: res => {
      const result = res?.listPMS?.pms;
      if (result) {
        setPmsList(result);
      }
    },
  });

  useEffect(() => {
    queryPMSList();
  }, []);

  return (
    <div className="pms-integrations">
      <div className="header-wrapper">
        <span>{t('cms.sidebar.menu.pms_integrations')}</span>
        {!loading && pmsList.length > 0 && (
          <Button
            type="primary"
            icon="plus"
            onClick={handleShowCreateModal}
            style={{ fontWeight: 600 }}
          >
            {t('cms.pms_integrations.empty.add_btn')}
          </Button>
        )}
      </div>
      <main>
        {loading && <Spin style={{ marginTop: 172 }} />}
        {!loading &&
          (pmsList.length === 0 ? (
            <EmptyPage t={t} setVisible={handleShowCreateModal} />
          ) : (
            <PMSList t={t} list={pmsList} refetch={queryPMSList} />
          ))}
      </main>
      <CreatePMSModal
        t={t}
        onClose={handleCancelCreateModal}
        visible={showCreateModal}
        refetch={queryPMSList}
      />
    </div>
  );
};

export default PMSIntegrations;
